angular.module('gym.components').directive('reportAggregateValueFields', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/report_aggregate_value_fields.html.slim'),
    scope: {
      report: '='
    },
    controller: ["$scope", "$filter", function($scope, $filter) {
      var aggregateFunctionLabelMap, clearFilter, getAvailableColumns, getAvailableFilterOperators, minMaxFunc, ref, ref1, sumAvgFunc;
      $scope.enabled = (ref = $scope.report.report_aggregates_attributes) != null ? ref.length : void 0;
      $scope.params = {};
      $scope.enable = function() {
        return $scope.enabled = true;
      };
      getAvailableColumns = function(section) {
        var allColumns;
        allColumns = $scope.report.report_columns_options[section];
        return _.filter(allColumns, function(column) {
          var functions;
          functions = $scope.report.aggregate_functions[column.data_type];
          return functions && functions.indexOf($scope.aggregate.aggregate_function) >= 0;
        });
      };
      clearFilter = function() {
        if ($scope.aggregate) {
          $scope.aggregate.filter_present = false;
          $scope.aggregate.operator = void 0;
          $scope.aggregate.operator_label = void 0;
          $scope.aggregate.user_value = void 0;
          $scope.aggregate.relative_date = void 0;
          $scope.aggregate.number = void 0;
          $scope.aggregate.period = void 0;
          return $scope.aggregate.multiplier = void 0;
        }
      };
      $scope.onTypeChange = function(val) {
        var ref1, ref2;
        $scope.report.errors['report_aggregates.table_and_column'] = void 0;
        $scope.report.errors['report_aggregates.operator'] = void 0;
        $scope.report.errors['report_aggregates.user_value'] = void 0;
        if (val !== ((ref1 = $scope.aggregate) != null ? ref1.aggregate_type : void 0)) {
          clearFilter();
        }
        if (!val) {
          if ((ref2 = $scope.aggregate) != null ? ref2.id : void 0) {
            $scope.aggregate._destroy = 1;
          } else {
            $scope.report.report_aggregates_attributes = [];
          }
          if ($scope.aggregate) {
            return $scope.aggregate.aggregate_type = val;
          }
        } else {
          if (!$scope.report.report_aggregates_attributes.length) {
            $scope.report.report_aggregates_attributes.push({
              position: 1
            });
            $scope.aggregate = $scope.report.report_aggregates_attributes[0];
          } else {
            $scope.aggregate._destroy = void 0;
          }
          $scope.aggregate.aggregate_type = val;
          if (val === 'record_count') {
            $scope.aggregate.aggregate_function = 'count';
            $scope.onFunctionChange();
          } else {
            $scope.aggregate.aggregate_function = void 0;
          }
          $scope.params = {};
          return $scope.aggregate.table_and_column = "";
        }
      };
      aggregateFunctionLabelMap = {
        sum: 'Total',
        avg: 'Average',
        min: 'Minimum / Earliest',
        max: 'Maximum / Latest',
        count: 'Count'
      };
      sumAvgFunc = [
        {
          label: 'Total',
          value: 'sum'
        },
        {
          label: 'Average',
          value: 'avg'
        }
      ];
      minMaxFunc = [
        {
          label: 'Minimum / Earliest',
          value: 'min'
        },
        {
          label: 'Maximum / Latest',
          value: 'max'
        }
      ];
      $scope.getAggregateFunctions = function() {
        switch ($scope.aggregate.aggregate_type) {
          case 'sum_avg':
            return sumAvgFunc;
          case 'min_max':
            return minMaxFunc;
        }
      };
      $scope.onColumnChange = function() {
        var column, columns;
        $scope.report.errors['report_aggregates.table_and_column'] = void 0;
        if ($scope.aggregate.aggregate_function !== 'count') {
          columns = $scope.report.report_columns_options[$scope.params.section];
          column = _.find(columns, function(item) {
            return item.table_and_column === $scope.aggregate.table_and_column;
          });
          $scope.params.column = column;
          if (column) {
            return $scope.aggregate.label = `${aggregateFunctionLabelMap[$scope.aggregate.aggregate_function]} ${column.label}`;
          }
        }
      };
      $scope.onSectionChange = function() {
        var columnSection;
        $scope.report.errors['report_aggregates.table_and_column'] = void 0;
        if ($scope.aggregate.aggregate_function === 'count' && $scope.params.section) {
          $scope.aggregate.table_and_column = `${$scope.report.aggregate_table_names_map[$scope.params.section]}:id`;
          columnSection = $scope.report.column_section_name_map[$scope.params.section];
          return $scope.aggregate.label = `${columnSection || $filter('humanize')($scope.params.section)} Count`;
        } else {
          return $scope.availableColumns = getAvailableColumns($scope.params.section);
        }
      };
      $scope.onFunctionChange = function() {
        return $scope.availableSections = _.filter($scope.report.aggregate_sections, function(section) {
          var ref1;
          return ((ref1 = getAvailableColumns(section)) != null ? ref1.length : void 0) > 0;
        });
      };
      getAvailableFilterOperators = function() {
        var dataType, operators, ref1;
        dataType = $scope.aggregate.aggregate_function === 'count' ? 'number' : (ref1 = $scope.params.column) != null ? ref1.data_type : void 0;
        if (!dataType) {
          return [];
        }
        operators = $scope.report.report_filters_operators[dataType];
        return _.filter(operators, function(operator) {
          var ref2, ref3;
          return ((ref2 = $scope.aggregate.aggregate_function) === 'min' || ref2 === 'max') || ((ref3 = operator[0]) !== 'Is blank' && ref3 !== 'Is not blank');
        });
      };
      $scope.onConditionChanged = function() {
        var condition;
        $scope.report.errors['report_aggregates.operator'] = void 0;
        condition = $scope.params.condition;
        $scope.aggregate.operator_label = (condition != null ? condition[0] : void 0) || void 0;
        return $scope.aggregate.operator = (condition != null ? condition[1] : void 0) || void 0;
      };
      $scope.getSectionName = function(section) {
        var columnSection, name;
        columnSection = $scope.report.column_section_name_map[section];
        name = $filter('humanize')(section);
        if ($scope.aggregate.aggregate_function === 'count') {
          return `${columnSection} count` || `${name} count`;
        } else {
          return name;
        }
      };
      $scope.$watch('aggregate.table_and_column', function() {
        var ref1;
        if ((ref1 = $scope.aggregate) != null ? ref1.table_and_column : void 0) {
          return $scope.availableFilterOperators = getAvailableFilterOperators();
        }
      });
      $scope.$watch('aggregate.user_value', function() {
        return $scope.report.errors['report_aggregates.user_value'] = void 0;
      });
      if ($scope.report.report_aggregates_attributes.length) {
        $scope.aggregate = $scope.report.report_aggregates_attributes[0];
        $scope.params.section = _.find($scope.report.aggregate_sections, function(section) {
          if ($scope.aggregate.table_and_column === `${$scope.report.aggregate_table_names_map[section]}:id`) {
            return true;
          }
          return _.find($scope.report.report_columns_options[section], function(column) {
            return column.table_and_column === $scope.aggregate.table_and_column;
          });
        });
        $scope.onFunctionChange();
        $scope.onColumnChange();
        $scope.onSectionChange();
        if ((ref1 = $scope.aggregate) != null ? ref1.table_and_column : void 0) {
          $scope.availableFilterOperators = getAvailableFilterOperators();
        }
        if ($scope.aggregate.operator) {
          return $scope.params.condition = _.find($scope.availableFilterOperators, function(operator) {
            return operator[0] === $scope.aggregate.operator_label;
          });
        }
      }
    }]
  };
});
